import { FaFacebook, FaLinkedin, FaInstagram } from "react-icons/fa6";

export default function Footer({ categories }) {
    return (
        <footer className="relative bg-gray-800 text-gray-300 py-5 mt-10  rounded-t-2xl overflow-hidden px-4 sm:px-6 md:px-8 lg:px-12 xl:px-16">
            {/* Newsletter Section at the Top */}
            <div className="text-left pt-10">
                <h2 className="text-3xl font-bold text-white-400">Be a part of building a greater environment with us!</h2>
                <p className="text-md mt-2">Together, we lead the way in sustainable innovation, developing solutions that monitor the environment and guide us toward a greater future.</p>
                {/* <div className="mt-4 flex justify-center space-x-4">
                    <button className="bg-green-400 text-black px-6 py-2 rounded-md font-semibold">Get in Touch</button>
                    <button className="bg-green-400 text-black px-6 py-2 rounded-md font-semibold">Careers</button>
                </div> */}
            </div>

            <hr className="border-gray-700 my-8" />

            {/* Footer Main Section */}
            <div className="container mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4 relative z-10">
                {/* Left - Social Media & Copyright */}
                <div>
                    <div className="flex space-x-4">
                        <a href="https://www.facebook.com/sunteknolozychennai/"                             target="_blank"
                            rel="noopener noreferrer" className="text-white-400 text-2xl">
                            <FaFacebook />
                        </a>
                        <a href="https://www.linkedin.com/company/sun-teknolozy/"                              target="_blank"
                            rel="noopener noreferrer" className="text-white-400 text-2xl">
                            <FaLinkedin />
                        </a>
                        <a href="https://www.instagram.com/sunteknolozy/?igsh=dnI1NHVidzZzejAx#"                              target="_blank"
                            rel="noopener noreferrer" className="text-white-400 text-2xl">
                            <FaInstagram />
                        </a>
                    </div>
                    <p className="mt-4 text-sm">&copy; {new Date().getFullYear()} Sun Teknolozy</p>
                    <p className="mt-2 text-sm">
                        <a
                            href="https://maps.app.goo.gl/jkkqVosqujg2t3Sy6"
                            target="_blank"
                            rel="noopener noreferrer"
                            className=""
                        >
                            STUDIO-10, Vasavi Street, Plot No. 32 & 33, Kamala Nagar, Kelambakkam, Chennai-603103, Tamil Nadu, India
                        </a>
                    </p>
                </div>

                {/* Right - Quick Links & Contact */}
                <div>
                    <h3 className="text-lg font-semibold text-white">Products</h3>
                    <ul className="mt-2 space-y-2">
                        {categories.map((category) => (
                            <li key={category.name} className="hover:text-green-400">
                                <a href={`/products/${category.id}`} className="hover:text-green-400">{category.name}</a>

                            </li>
                        ))}
                    </ul>
                </div>

                <div>
                    <h3 className="text-lg font-semibold text-white">Quick Links</h3>
                    <ul className="mt-2 space-y-2">
                        <li><a href={`/careers`} className="hover:text-green-400">Careers</a></li>
                        <li><a href={`/contact`} className="hover:text-green-400">Contact Us</a></li>
                    </ul>
                </div>

                <div>
                    <h3 className="text-lg font-semibold text-white">Sales</h3>
                    <p>admin@sunteknolozy.com</p>
                    <p>+91 9790935128</p>
                    <p>044 - 35661951</p>
                </div>

                <div>
                    <h3 className="text-lg font-semibold text-white">Service</h3>
                    <p>service@sunteknolozy.com</p>
                    <p>+91 7598725128</p>
                    <p>044 - 35661951</p>
                </div>
            </div>

            <div className='mb-[200px]'></div>

            {/* Large Suntek Branding at the Bottom */}
            <div className="absolute bottom-[-2vw] left-1/2 transform -translate-x-1/2 w-full text-center font-bold lowercase opacity-10 leading-none bg-clip-text text-transparent"
                style={{
                    fontSize: "clamp(50px, 10vw, 200px)",// Responsive text size
                    backgroundImage: "linear-gradient(to bottom, rgba(255,255,255,0.8), black)",
                }}>
                Sunteknolozy
            </div>



        </footer>
    );
}
